<mat-card>
  <div #exportContent>
    <div class="header">
      <div class="title">Restoration Metrics</div>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <div class="content">
      Restoration Metrics are designed to address system flexibility and response across the state.
      Where SAIDI/SAIFI values capture utilities' reported outage frequency and length,
      Restoration Metrics provide a more holistic view of grid resilience and the impacts to customers by county.
    </div>
  </div>
</mat-card>
